import { Controller } from "@hotwired/stimulus"

// Candidate picker for AIRDROP's "Replace image" action (card #2835) --
// Mission Summary hero image slots only. Rendered into the global
// content_modal (DecksController#image_candidates), one photo grid tile per
// live alternative from the slot's own mission photo pool
// (Airdrop::HeroImageCandidates -- rating desc / place_id asc / image_id asc,
// excluding hide/poor and anything already placed elsewhere on this deck).
//
// Selecting a candidate PATCHes DecksController#replace_image, which writes
// the swap through the SAME element-id override layer every other show-page
// edit uses (ADR-0094) and broadcasts a slide refresh over the deck's
// existing turbo_stream_from "deck_#{id}" subscription -- the open show-page
// tab updates the canvas image itself via that broadcast, not via anything
// this controller does directly. This controller's only job on success is to
// close the modal; DeckElementContextMenuController's
// turbo:before-stream-render listener (card #2834/#2903) already re-attaches
// every right-click/edit affordance after the broadcast re-renders the
// slide, so nothing else here needs to touch that DOM.
//
// Deliberately does NOT touch rate_image -- browsing alternatives is
// non-destructive to the shared photo pool by design (card #2835 rescope,
// 2026-08-18); marking a photo hide/poor stays a separate, explicit action
// this controller never calls.
export default class extends Controller {
  static targets = ["error"]
  static values = { deckId: Number, slideIndex: Number, elementIndex: Number }

  async select(event) {
    const button = event.currentTarget
    const imageId = button.dataset.imageId
    if (!imageId) return

    this._clearError()
    button.disabled = true

    try {
      const response = await fetch(this._url(), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": this._csrfToken(),
        },
        body: JSON.stringify({ image_id: imageId }),
      })

      const data = await response.json()
      if (!response.ok) throw new Error((data.errors || []).join(", ") || `save failed: ${response.status}`)

      this._close()
    } catch (error) {
      button.disabled = false
      this._showError(error.message)
    }
  }

  _url() {
    return `/decks/${this.deckIdValue}/element/${this.slideIndexValue}/${this.elementIndexValue}/replace_image`
  }

  // Closes the SAME global <dialog id="content_modal"> every WIN picker/form
  // uses -- the native .close() call fires the 'close' event
  // content_modal_controller.js#handleNativeClose already listens for, which
  // clears the frame and restores focus, so nothing bespoke is needed here.
  _close() {
    document.getElementById("content_modal")?.close()
  }

  _showError(message) {
    if (this.hasErrorTarget) this.errorTarget.textContent = message
  }

  _clearError() {
    if (this.hasErrorTarget) this.errorTarget.textContent = ""
  }

  _csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
